import { Community } from '../../models';

export const COMMUNITY_TAG = 'communities';

export interface CommunitiesState {
  activeCommunity: any;
  communities: Community[] | undefined;
  // communityMap: { [uuid: string]: any/*Community*/[] };
}
